import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChatIcon from "@mui/icons-material/Chat";
import NotFound from "../../components/not-found/NotFound";
import ChatBox from "../../components/chatBox/ChatBox";
import { Completed_callAPi } from "../../services/userManagement";
import { dateFormatWithTime, formatDuration } from "../../utils/dateFormat";
import { toastMessage } from "../../utils/toastMessage";

const ConsultantQueriesListing = ({ consultantId, search = "", startDate = "", endDate = "" }) => {
  const [queries, setQueries] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);

  useEffect(() => {
    setPage(1);
  }, [consultantId, search, startDate, endDate]);

  useEffect(() => {
    const fetchQueries = async () => {
      if (!consultantId) return;
      setLoading(true);
      try {
        const filter = {
          consultantId,
          consultationMode: "chat",
          usedFor: "query",
        };
        if (startDate || endDate) {
          filter.timeRange = "custom";
          filter.timeRangeStartDate = startDate || "1970-01-01";
          filter.timeRangeEndDate = endDate || new Date().toISOString().slice(0, 10);
        }
        const response = await Completed_callAPi({
          page: String(page),
          limit: "10",
          ...(search?.trim() ? { search: search.trim() } : {}),
          filter,
        });
        if (response?.data?.code !== 200) throw new Error(response?.data?.message);
        setQueries(response?.data?.result?.list || []);
        setTotal(response?.data?.result?.total || 0);
      } catch (error) {
        setQueries([]);
        setTotal(0);
        toastMessage(error?.message || "Failed to fetch consultant queries", "error", "queries");
      } finally {
        setLoading(false);
      }
    };
    fetchQueries();
  }, [consultantId, page, search, startDate, endDate]);

  const userName = (item) => item?.request_form?.firstName || item?.userDetails?.userId || "User";

  return (
    <>
      {/* <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ padding: "14px 20px", border: "1px solid #ffd0d0", borderRadius: 10, background: "#fff7f7" }}>
          <div style={{ color: "#777", fontSize: 12 }}>Accepted Queries</div>
          <strong style={{ fontSize: 24, color: "#ff7474" }}>{total}</strong>
        </div>
        <div style={{ padding: "14px 20px", border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff" }}>
          <div style={{ color: "#777", fontSize: 12 }}>Showing on this page</div>
          <strong style={{ fontSize: 24 }}>{queries.length}</strong>
        </div>
      </div> */}

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead>
            <tr>
              <th>S. No.</th><th>Date & Time</th><th>User ID</th><th>User Name</th>
              <th>Query / Problem</th><th>Duration</th><th>Amount</th><th>Chat</th>
            </tr>
          </thead>
          <tbody>
            {!loading && queries.map((item, index) => (
              <tr key={item?._id || index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{item?.createdAt ? dateFormatWithTime(item.createdAt) : "---"}</td>
                <td>{item?.userDetails?.userId || "---"}</td>
                <td>{userName(item)}</td>
                <td style={{ minWidth: 220 }}>{item?.request_form?.concern || "---"}</td>
                <td>{formatDuration(item?.onCompletion?.callDurationInSeconds || 0)}</td>
                <td>{Number(item?.onCompletion?.amountToDeduct || 0).toFixed(2)}</td>
                <td>
                  {item?.threadId ? (
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setSelectedQuery(item)}>
                      <ChatIcon style={{ fontSize: 16, marginRight: 5 }} /> View Chat
                    </button>
                  ) : <span style={{ color: "#999" }}>No chat</span>}
                </td>
              </tr>
            ))}
            {!loading && !queries.length && <NotFound cols={8} msg="No accepted chat queries found" />}
            {loading && <tr><td colSpan="8" className="text-center py-4">Loading queries...</td></tr>}
          </tbody>
        </table>
      </div>

      {total > 10 && (
        // <Pagination activePage={page} itemsCountPerPage={10} totalItemsCount={total} pageRangeDisplayed={5} onChange={setPage} />
     <Pagination
  activePage={page}
  itemsCountPerPage={10}
  totalItemsCount={total}
  pageRangeDisplayed={5}
  onChange={setPage}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination"
/>
     
     )}

      {selectedQuery?.threadId && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 10, width: "min(850px, 96vw)", height: "min(760px, 90vh)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ padding: "14px 18px", borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div><strong><VisibilityIcon style={{ fontSize: 18, marginRight: 6 }} />Chat with {userName(selectedQuery)}</strong><div style={{ color: "#777", fontSize: 12 }}>{selectedQuery?.request_form?.concern || "Query conversation"}</div></div>
              <button type="button" aria-label="Close chat" onClick={() => setSelectedQuery(null)} style={{ border: 0, background: "transparent", fontSize: 28, cursor: "pointer" }}>&times;</button>
            </div>
            <div style={{ flex: 1, overflow: "hidden" }}>
              <ChatBox threadId={selectedQuery.threadId} userName={userName(selectedQuery)} userId={selectedQuery.user_id} onClose={() => setSelectedQuery(null)} isConsultant={false} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultantQueriesListing;
